<template>
  <div v-if="isOpen" class="feedback-banner">
    <InfoIcon class="icon" />
    <span>{{ content }}</span>
    <ClosingIcon class="close" @click="handleClose" />
  </div>
</template>

<script lang="ts" setup>
import ClosingIcon from '~/assets/icons/icon-banner-close.svg?component'
import InfoIcon from '~/assets/icons/icon-check.svg?component'

const { content = '' } = defineProps<{
  content: string
  type: 'info' | 'success' | 'error' | 'warning'
}>()

const isOpen = ref(true)
const handleClose = () => {
  isOpen.value = false
}
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.feedback-banner {
  @apply relative py-3.5 bg-success-light z-1 text-sm font-medium flex items-center;
  color: rgba(0, 0, 0, 0.9);

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    z-index: -1;
    top: 0;
    bottom: 0;
    @apply bg-success-light;
  }

  &.hidden {
    display: none;
  }

  span {
    @apply mx-5;
  }
}

.icon {
  @apply min-w-[20px];
}

.close {
  @apply ml-auto min-w-[18px];

  :deep(path) {
    fill: black;
  }
}
</style>
